import { IdentifiableObjectDTO } from '@dto/IdentifiableObjectDTO';

export class SpecialityDTO extends IdentifiableObjectDTO<number> {
  public name: string;
}